import { Directive, ElementRef, HostListener, Renderer2, inject, input } from '@angular/core';
import { AbstractControl, NgControl } from '@angular/forms';
import { integerOnly } from '@app/shared/base-form/patterns';

@Directive({ selector: '[appLimitInputValue]' })
export class LimitInputValueDirective {
    private ngControl = inject(NgControl);
    private renderer = inject(Renderer2);
    private el = inject(ElementRef);

    readonly control = input.required<AbstractControl>({ alias: 'appLimitInputValue' });

    @HostListener('input', ['$event'])
    onInput(event: InputEvent) {
        const inputElement = event.target as HTMLInputElement;
        const form = this.ngControl.control;
        if (inputElement) {
            const inputValue = inputElement.value;
            const control = this.control();
            if (control.errors?.maxlength) {
                inputElement.value = inputValue.slice(0, control.errors.maxlength.requiredLength);
                this.renderer.setProperty(this.el.nativeElement, 'value', inputElement.value);
            }
            if (!integerOnly.test(inputElement.value)) {
                inputElement.value = inputValue.slice(0, -1);
            }
            form?.setValue(inputElement.value, { emitEvent: false });
        }
    }
}
